import { render, staticRenderFns } from "./Gruppen.vue?vue&type=template&id=65dda70a&scoped=true&"
import script from "./Gruppen.vue?vue&type=script&lang=js&"
export * from "./Gruppen.vue?vue&type=script&lang=js&"
import style0 from "./Gruppen.vue?vue&type=style&index=0&id=65dda70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dda70a",
  null
  
)

export default component.exports